import { classNames, useEffect, useQuery } from 'libs/react';
import { React } from 'libs/react';
import { FormSelect } from 'components/form/FormSelect';
import { TermsQuery } from 'graphql/Term/queries/TermsQuery';
/**
 * @component TermSelect
 * @since 1.0.0
 */
export function TermSelect(props) {
    var _a;
    const { label, infos, name, value, returnType, onChange, termsInput } = Object.assign({ termsInput: {} }, props);
    const [data, ready, error] = useQuery(TermsQuery, {
        variables: {
            input: Object.assign({}, termsInput)
        }
    });
    const itemList = (_a = data === null || data === void 0 ? void 0 : data.terms.items) !== null && _a !== void 0 ? _a : [];
    useEffect(() => {
        const list = data === null || data === void 0 ? void 0 : data.terms.items;
        if (returnType !== 'object' ||
            !onChange ||
            !list ||
            list.length !== 1) {
            return;
        }
        const only = list[0];
        if (only != null && value !== only.id) {
            onChange(only);
        }
    }, [returnType, onChange, data === null || data === void 0 ? void 0 : data.terms.items, value]);
    const options = itemList.map((t) => ({
        label: t.title,
        value: t.id
    }));
    const className = classNames('term-select', props.className);
    // A single option stays plain text only when the field has no label
    // (the deal terms panel). With a label, keep the select so the field
    // name stays visible next to the value.
    if (options.length === 1 && !label) {
        return React.createElement("div", { className: className }, options[0].label);
    }
    return (React.createElement(FormSelect, { className: className, name: name, label: label, infos: infos, value: value, options: options, onChange: (value) => {
            var _a;
            if (onChange) {
                if (returnType === 'object') {
                    onChange((_a = itemList.find((o) => o.id === value)) !== null && _a !== void 0 ? _a : null);
                }
                else {
                    onChange(value);
                }
            }
        } }));
}
